import { render, staticRenderFns } from "./ConfirmPwd.vue?vue&type=template&id=6aa99106"
import script from "./ConfirmPwd.vue?vue&type=script&lang=js"
export * from "./ConfirmPwd.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPwd.vue?vue&type=style&index=0&id=6aa99106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports